import React from "react";

import { FirebaseContext } from "./FirebaseContext";
import {
  firebaseApp,
  firebaseAuth,
  firebaseFirestore,
  firebaseStorage,
} from "./FirebaseInterface";

/**
 * Standalone component to contain firebase information, and make it accessible
 * to all child components.
 * @param children Child components on the react tree.
 */
function FirebaseProvider({ children }: React.PropsWithChildren) {
  const firebaseContextValue = React.useMemo(
    () => ({
      app: firebaseApp,
      auth: firebaseAuth,
      firestore: firebaseFirestore,
      storage: firebaseStorage,
    }),
    [firebaseApp, firebaseAuth, firebaseFirestore],
  );

  return (
    <FirebaseContext.Provider value={firebaseContextValue}>
      {children}
    </FirebaseContext.Provider>
  );
}

export { FirebaseProvider };
